import axios from "axios";
const { ACTION, ACTION_ADD_TO_CART, PRODUCT_ID, PRODUCT_QUANTITY, LINKS, INITIAL_QUANTITIES, REQUEST_DEFAULT_CONFIG} = require('./parameters/RequestParameters');
const siteURL = window.location.origin;
const apiURL = 'https://api2.comprasocial.me/';
const apiUserEndpoint  = 'ig/user';
const apiMediaEndpoint  = 'ig/media';

axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  };

export default {
    name: "App",
    components: {},
    data: function() {
        return {
            product: {
                id: '',
                array: null,
                selected: {},
                initialUnitPrice: 0,
                initialQuantity: null,
                links: [],
                linkDisplay: '',
            },
            input: {
                field: "",
                postUrl: ""
            },
            icons: {
                crystal: 'https://comprasocial.me/wp-content/uploads/2019/07/Crystal@2x.png',
                product: 'https://comprasocial.me/wp-content/uploads/2019/09/icon-like.png',
                crossProduct: 'https://comprasocial.me/wp-content/uploads/2020/10/icon_cuore.svg',
                confirm: 'https://comprasocial.me/wp-content/uploads/2019/09/checked@2x.png'
            },
            steps: {
                isFirst: true,
                isSecond: false,
                isSecondUsername: false,
                isSecondPhotoURL: false,
                isLoading: false,
                isAddingToCart: false,
                orderCompleted: false
            },
            user: {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            },
            errors: {
                noMedia: false,
                notFound: false,
                noMediaSelected: false
            },
            dictionary: {}
        };
    },
    methods: {
        getProductPrice: function(productIndex){
            if(productIndex){
                const product = this.product.array[productIndex];
                return  product.sale_price ? Number.parseFloat(product.sale_price).toFixed(2) :  Number.parseFloat(product.regular_price).toFixed(2);
            }
            if(this.product.selected && this.product.selected.regular_price) {
                return this.product.selected.sale_price ? Number.parseFloat(this.product.selected.sale_price).toFixed(2) :  Number.parseFloat(this.product.selected.regular_price).toFixed(2);
            }
            return 0.00.toFixed(2)
        },
        getProfilePhotosClass() {
            if( this.user.medias.length <= 2 ){
                return 'cs4-profilePhotosTwo';
            } else if (this.user.medias.length > 2 && this.user.medias.length <= 4  ) {
                return  'cs4-profilePhotosFour';
            }
            return 'cs4-profilePhotos';
        },
        cleanInputField() {
            this.input.field = this.input.field.replace(" ",'');
            this.input.field = this.input.field.replace(new RegExp('.*instagram.com/'),'');
            this.input.field = this.input.field.replace(new RegExp("\\?.*"),'');
        },
        isInputFieldAInstagramPhoto(){
            return this.input.field.match(new RegExp('p\\/|reel\\/|tv\\/'));
        },
        goToSecondStep: function() {
            this.resetUserInfo();
            this.cleanInputField();
            if(this.input.field.replace(" ", "") === "") {
                const inputField = document.getElementById("inputField");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.steps.isSecond = false;
                this.steps.isFirst = false;
                this.steps.isLoading = true;
                if (this.isInputFieldAInstagramPhoto()) {
                    this.setPhotoAndUserData(this.input.field.replace('p\\/|reel\\/|tv\\/','').replace('/',''));
                } else {
                    this.setUserData(this.input.field).then(() => {
                        this.steps.isLoading = false;
                        this.steps.isSecond = true;
                        this.steps.isSecondUsername = true;
                        this.product.initialQuantity = this.user.followers;
                        if(this.user.medias.length >= 5) {
                            setTimeout(() => {this.setSlidingPhotos()}, 500);
                        }
                    }).catch(() => {
                        this.steps.isLoading = false;
                        this.steps.isSecond = true;
                        this.product.initialQuantity = this.user.followers;
                    })
                }
            }
        },
        setSlidingPhotos() {
            const slider = document.querySelector('.cs4-profilePhotos');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1.5; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        },
        setPhotoAndUserData: async function(photoCode){
            axios.post(apiURL + apiMediaEndpoint,{
                user: photoCode
            }).then(async (res) => {
                if(res.data === {}){
                    this.steps.isLoading = false;
                    this.input.field = this.input.field.replace('p\\/|reel\\/|tv\\/','');
                    this.product.links = [{shortcode: this.input.field}];
                    await this.addProductToCart();
                } else {
                    const result = res.data;
                    this.steps.isLoading = false;
                    this.steps.isSecond = true;
                    this.steps.isSecondPhotoURL = true;
                    this.user.profilePic = result.profilePic;
                    this.user.followers = result.followers;
                    this.user.username = result.username;
                    this.input.field = this.dictionary.instagramPhotoURL + result.shortcode;
                    this.product.links = [{shortcode: result.shortcode, img: result.img, likes: result.likes}];
                    this.product.linkDisplay = result.img;
                }
            });
        },
        setUserData: async function(username){
            return axios.post(apiURL + apiUserEndpoint,{
                user: username
            }).then(res => {
                this.user = res.data;
            });
        },
        isMediaInCrossMedia: function(media) {
            return this.product.links.includes(media);
        },
        onMediaClick: function(media) {
            if(this.errors.noMediaSelected) {
                this.errors.noMediaSelected = false;
            }
            if(this.isMediaInCrossMedia(media)){
                this.product.links.splice(this.product.links.findIndex((arrayElement) => arrayElement.shortcode === media.shortcode),1)
            } else {
                this.product.links.push(media);
            }
        },
        goToFirstStep(){
            this.input.field = "";
            this.input.postUrl = "";
            this.steps.isSecond = false;
            this.steps.isSecondUsername = false;
            this.steps.isSecondPhotoURL = false;
            this.steps.isAddingToCart = false;
            this.steps.orderCompleted = false;
            this.steps.isFirst = true;
            this.resetUserInfo();
            setTimeout(() => this.setSlider(),100);
        },
        resetUserInfo() {
            this.user = {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            }
        },
        increaseCartItemCounter() {
            const cartItemCounter = document.getElementById('cs-header__cartCounter');
            cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
        },
        addProductToCart: async function() {
            
            if(this.product.links.length === 0) {
                this.errors.noMediaSelected = true;
            } else {
                this.onToggleProductToCart();
                for( let mediaLink of this.product.links ){
                    const productRequestFormData = this.createAddToCartRequestBody(this.dictionary.productID, [this.dictionary.instagramPhotoURL + mediaLink.shortcode],null || mediaLink.likes);
                    await this.runAddToCartRequest(productRequestFormData);
                    this.increaseCartItemCounter();
                }
                this.onToggleProductToCart();
            }
            
        },
        onToggleProductToCart(){
            if(this.steps.isAddingToCart){
                this.steps.isLoading = false;
                this.steps.isAddingToCart = false;
                this.steps.orderCompleted = true;
            } else {
                this.steps.isLoading = true;
                this.steps.isSecond = false;
                this.steps.isFirst = false;
                this.steps.isSecondPhotoURL = false;
                this.steps.isSecondUsername = false;
                this.steps.isAddingToCart = true;
            }
        },
        createAddToCartRequestBody(productId, links, initQuantities){
            const formBody = new URLSearchParams();
            formBody.append(ACTION,ACTION_ADD_TO_CART);
            formBody.append(PRODUCT_ID, productId);
            formBody.append(PRODUCT_QUANTITY, 1);
            formBody.append(LINKS, links);
            if(initQuantities !== null){
                formBody.append(INITIAL_QUANTITIES, initQuantities);
            }
            return formBody;
        },
        runAddToCartRequest(requestBody){
            // return axios.post("https://ejuifjerui.free.beeceptor.com", requestBody,REQUEST_DEFAULT_CONFIG);
            // eslint-disable-next-line no-undef
            return axios.post(wc_add_to_cart_params.ajax_url, requestBody,REQUEST_DEFAULT_CONFIG);
        },
        verifyInputAndAddProductToCart(){
            if(this.input.postUrl.replace(" ", "") === "") {
                const inputField = document.getElementById("postUrl");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.input.field = this.input.postUrl;
                this.goToSecondStep();
            }
        },
        goToCheckout(){
            const cartButton = document.getElementsByClassName('cs-header__cartWrapper')[0];
            cartButton.click();
        }
    },
    mounted: function() {
        this.steps.isFirst = false;
        this.steps.isLoading = true;
        // axios.get( siteURL + '/static/dictionary-IT.json').then(
        // eslint-disable-next-line no-undef
        axios.get( siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/instagram/vip-post-boost/dictionary-' + currentLanguage + '.json').then(
            res => {
                this.dictionary = res.data;
                this.product.id = this.dictionary.productID;
                this.steps.isFirst = true;
                this.steps.isLoading = false;
            }
        )
    },
};
